import React from 'react';
import cn from 'classnames';

import { useHorizontalScroll } from 'utils/hooks';

import * as styles from './Tabs.module.scss';

export default function Tabs({ tabs, active, handleClick, className }) {
  const scrollRef = useHorizontalScroll();

  return (
    <div className={cn(styles.container, className)} ref={scrollRef}>
      {tabs.map(tab => {
        const isActive = active === tab;

        return (
          <button
            className={cn(styles.tab, isActive && styles.active)}
            key={tab}
            onClick={() => handleClick(tab)}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
